import { IBaseDiseaseWithItemInfo } from '@pharmsnap/shared/types'
import { defineComponent, PropType } from '@vue/composition-api'
import { Popper as PtPopper } from 'patsnap-biz'
import { getAsyncListTippyConfig } from '../config'
import { BDiseaseWithToolTipFetchListCard } from './BDiseaseWithToolTipFetchListCard'

export const BDiseaseWithToolTipPopperListCard = defineComponent({
  name: 'BDiseaseWithToolTipPopperListCard',
  props: {
    data: {
      type: Array as PropType<IBaseDiseaseWithItemInfo[]>,
      required: true,
    },
  },
  render() {
    return (
      <PtPopper data={{ data: this.data }} tippyConfig={getAsyncListTippyConfig()} component={BDiseaseWithToolTipFetchListCard}>
        {this.$slots.default}
      </PtPopper>
    )
  },
})
